import { STORAGE_KEY } from "../const";
const getPayments = (shopId) => {
  try {
    return JSON.parse(localStorage.getItem(`${shopId}-${STORAGE_KEY.PAYMENTS}`)) || [];
  } catch {
    return [];
  }
};

const setPayments = (shopId, payments) => {
  localStorage.setItem(`${shopId}-${STORAGE_KEY.PAYMENTS}`, JSON.stringify(payments));
};

const addPayment = (shopId, payment) => {
  const payments = getPayments(shopId);
  payments.push(payment);
  setPayments(shopId, payments);
};

const removePayment = (shopId, paymentId) => {
  const payments = getPayments(shopId).filter(p => p.payment_id !== Number(paymentId));
  setPayments(shopId, payments);
};

const setLastPaymentToLocalStorage = (shopId, payment) => {
  localStorage.setItem(`${shopId}-${STORAGE_KEY.LAST_PAYMENT}`, JSON.stringify(payment));
  addPayment(shopId, payment);
}

const getLastPaymentFromLocalStorage = (shopId) => {
  const paymentStr = localStorage.getItem(`${shopId}-${STORAGE_KEY.LAST_PAYMENT}`);
  return paymentStr ? JSON.parse(paymentStr) : null;
}

const addOrderToLocalStorage = (order, shopId) => {
  const key = `${shopId}-${STORAGE_KEY.ORDERS}`;

  let orders = [];
  try {
    orders = JSON.parse(localStorage.getItem(key)) || [];
  } catch {
    orders = [];
  }

  const alreadyExists = orders.some(o => o.id === order.id);
  if (alreadyExists) return;

  orders.push(order);
  localStorage.setItem(key, JSON.stringify(orders));
};


export const PaymentHelper = {
  getPayments,
  setPayments,
  removePayment,
  addPayment,
  setLastPaymentToLocalStorage,
  getLastPaymentFromLocalStorage,
  addOrderToLocalStorage
};